import BigNumber from 'bignumber.js';
import { Address } from 'viem';

import { api, cacheTags } from 'modules/api';
import { getPublicClient } from 'modules/api/getPublicClient';
import { ONE } from 'modules/common/const';
import { getStakeTokenRatio } from 'modules/liquidStaking/methods/getStakeTokenRatio';

interface IGetStakeTokenRatioArgs {
  poolAddress?: Address;
}

export const { useGetStakeTokenRatioQuery } = api.injectEndpoints({
  endpoints: build => ({
    getStakeTokenRatio: build.query<BigNumber, IGetStakeTokenRatioArgs | void>({
      queryFn: async params => {
        const client = getPublicClient();
        const { poolAddress } = params || {};

        const result = await getStakeTokenRatio(client, poolAddress);

        return { data: ONE.div(result) };
      },
      providesTags: [cacheTags.liquidStaking],
    }),
  }),
});
